// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dic[data-v-c45150fe]{display:-webkit-box;display:-ms-flexbox;display:flex;margin-bottom:5px}", ""]);
// Exports
module.exports = exports;
